import _ from 'lodash'
import { find } from 'lodash/collection'
import { get as lodashGet } from 'lodash/object'
import Cookies from 'universal-cookie'
import { ERROR_LANG, LANG_STRINGS } from '../lang'
import { gTagForUserId } from '../tagManager'
import { copyToClipboard } from './copyToClipboard'
import { NotificationManager } from 'react-notifications'
import { range as lodashRange } from 'lodash/util'
import { LOGIN_AS_GURDIAN } from '../constants/cookies'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { shareWithReqularWhatsApp, sharingViaWhatsApp } from './sharingWA'

const cookies = new Cookies()

export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === 'localhost.pasarpolis.io' ||
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

export const getAgeFromDob = (dob, format = 'DD/MM/YYYY') => {
  const date = moment(dob, format, true)
  if (date._isValid) {
    const years = moment().diff(date, 'years', true)
    const months = moment().diff(date, 'months', true)
    const days = moment().diff(date, 'days', true)
    return {
      years,
      months,
      days,
    }
  } else {
    return undefined
  }
}

export const getNameOrKeyForDropdown = (data, key, valCode = 'value') => {
  if (get(data, `${key}_data`, '')) {
    return get(data, `${key}_data.${valCode}`, '-')
  } else {
    return get(data, key, '-')
  }
}

export const getTransportValue = (transportType) => {
  switch (transportType) {
    case 'land':
      return LANG_STRINGS.land
    case 'sea':
      return LANG_STRINGS.sea
    case 'air':
      return LANG_STRINGS.air
    default:
      return ''
  }
}

export const getHardcopyType = (type) => {
  switch (type) {
    case 'send-to-customer':
      return LANG_STRINGS.sendToCustomer
    case 'send-to-agent':
      return LANG_STRINGS.sendToAgent
    case 'send-to-another-address':
      return LANG_STRINGS.sendToAnotherAddress
    case 'send-to-pasarpolis':
      return LANG_STRINGS.sendToPasarpolis
    default:
      return ''
  }
}

export const getAddress = (addrData, provinces, cities) => {
  if (isEmpty(addrData) || isEmpty(provinces) || isEmpty(cities)) {
    return {}
  } else {
    const addr = {}
    addr.province_code = get(addrData, 'province_code', '')
    addr.city_code = get(addrData, 'city_code', '')
    addr.postal_code = get(addrData, 'postal_code', '')
    addr.address = get(addrData, 'address', '')
    addr.province_name = find(provinces, {
      province_code: addr.province_code,
    }).province_name
    const citydata = find(cities, { city_code: addr.city_code })
    addr.city_name = citydata.city_name
    addr.region = citydata.region
    return addr
  }
}

export function getGlobalStateObject(agentDetails = {}) {
  let isAggregatorAgent = false
  let isInternalAgent = false
  let isGojekAgent = false
  let isStaffAgent = false
  let isAggregatorStaffAgent = false
  let isRetailStaffAgent = false
  let isAggregatorDownlineAgent = false
  const tags = lodashGet(agentDetails, 'agent_tags', []) || []
  const isRMMapped = !isEmpty(agentDetails?.tag_handler_details)
  tags.forEach((tag) => {
    switch (tag.code) {
      case 'GOJEK':
        isGojekAgent = true
        break
      case 'AGGREGATOR-STAFF':
        isAggregatorStaffAgent = true
        break
      case 'RETAIL-STAFF':
        isRetailStaffAgent = true
        break
      default:
        break
    }
    switch (tag.tag_type) {
      case 'aggregator':
        isAggregatorAgent = true
        break
      case 'aggregator-downline':
        isAggregatorDownlineAgent = true
        break
      case 'internal':
        isInternalAgent = true
        break
      case 'staff':
        isStaffAgent = true
        break
      default:
        break
    }
  })
  return {
    agentDetails,
    isAggregatorAgent,
    isInternalAgent,
    isGojekAgent,
    isStaffAgent,
    isAggregatorStaffAgent,
    isRetailStaffAgent,
    isRMMapped,
    getAgentDetailData: agentDetails,
    isGojekDriver: isGojekAgent,
    isGuardianAgentLogin: cookies.get(LOGIN_AS_GURDIAN) || false,
    isAggregatorDownlineAgent,
  }
}

export function formatMoney(
  amount,
  decimalCount = 2,
  currSymbol = 'Rp',
  decimal = ',',
  thousands = '.'
) {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '- ' : ''

    const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()
    const j = i.length > 3 ? i.length % 3 : 0

    return (
      negativeSign +
      currSymbol +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    )
  } catch (e) {
    // no message has been returned so left empty in this case
  }
}
export function formatNumber(amount, { prefix, suffix }) {
  if (_.isNil(amount)) return ''
  let _amount = String(amount).replace('.', ',')
  if (prefix) _amount = `${prefix} ${_amount}`
  if (suffix) _amount = `${_amount} ${suffix}`
  return _amount
}

export function formatPercentage(amount) {
  if (_.isNil(amount)) return ''
  let _amount = String(amount).replace('.', ',')
  return `${_amount}%`
}

export function getConvertedCurrency(amount, exchangeRate = 1, decimalCount = 0) {
  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()

  return (i / exchangeRate).toFixed(decimalCount)
}
export function getIDRCurrency(amount, exchangeRate, decimalCount = 2) {
  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()

  return i * exchangeRate
}

export function clearToken() {
  cookies.remove('agent_code')
  cookies.remove('agent_token')
  // cookies.remove('agent_id')
  cookies.remove(LOGIN_AS_GURDIAN)
  gTagForUserId('')
}

export function getHeaderUploadFile() {
  return {
    'Content-Type': 'multipart/form-data',
  }
}

export function getHeader() {
  const headers = {
    'Content-Type': 'application/json',
    withCredentials: true,
    // Authorization: document.cookie
  }
  const dependentAgentCode = cookies.get(LOGIN_AS_GURDIAN)
  if (dependentAgentCode) {
    headers[LOGIN_AS_GURDIAN] = dependentAgentCode
  }
  return headers
}

export function getHeaderWithoutToken() {
  return {
    'Content-Type': 'application/json',
    // Authorization: document.cookie
  }
}

export function getErrorMessage(statusCode, errorCode) {
  if (errorCode) {
    switch (errorCode) {
      case 'PP-401':
        return 'Kode OTP tidak valid, silakan coba lagi'
      case 'PP-403':
        return 'Nomor HP belum terdaftar. Silakan daftar sekarang sebagai mitra PasarPolis'
      case 'PP-406':
        return 'Akun staf Anda tidak dapat digunakan saat ini.'
      case 'PP-402':
      case 'PP-404':
        return 'Nomor HP sudah terdaftar. Silakan gunakan nomor lain atau login sekarang'
      case 'PP-405':
        return 'Email sudah terdaftar. Silakan gunakan email lain atau login sekarang.'
      case 'PP-AS-W-400':
        return 'Hanya dapat mencairkan diatas Rp '
      case 'PP-AS-W-405':
        return 'Anda sudah melebihi batas maksimal penarikan hari ini'
      case 'PP-AS-W-406':
        return 'Request anda tidak dapat diproses untuk agen internal'
      case 'PP-AS-1004':
        return 'Silahkan gunakan email Pasar polis anda untuk registrasi'
      case 'PP-DV-401':
        return 'KTP sudah pernah dipakai agent lain'
      case 'PP-DV-402':
        return 'NPWP sudah pernah dipakai agent lain'
      case 'PP-DV-403':
        return 'Anda sudah pernah mengirimkan dokumen. Harap tunggu persetujuan dari PasarPolis'
      case 'PP-DV-404':
        return 'NIB sudah pernah dipakai agent lain'
      case 'PP-AS-W-401':
        return 'Nomor Rekening Tidak Terdaftar'
      case 'PP-AS-W-404':
        return ERROR_LANG.gopayWithdrawlMax10million
      case 'PP-UNAUTH-401':
        return 'Unauthorize Access'
      case 'PP-IS-POL-REN-4002':
        return 'Depreciation rate is not set'
      case 'PP-PAYMENT-NOT-ALLOWED-AT-THE-MOMENT':
        return 'Pembayaran tidak bisa dilakukan saat ini'
      case 'PP-IS-PKGDETAILS-4004':
        return 'Batas Nominal Pertanggungan Pihak Ketiga tidak didukung oleh Pihak Asuransi.'
      case 'PP-IS-PKGDETAILS-4003':
        return 'Perlindungan Tambahan ini tidak berlaku untuk Pihak Asuransi yang dipilih.'
      // case 'PP-OB-APP-4000':
      //     return 'Policy In Progress'
      case 'PP-AS-APP-4007':
        return ERROR_LANG.invalidPostalCode
      case 'PP-IS-PE-ETIQA-4002':
        return ERROR_LANG.tsiLimitExceeded
      case 'PP-AS-W-402':
        return ERROR_LANG.errorForWithdrawalWithoutPolicy
      case 'PP-AS-1003':
        return ERROR_LANG.referralCodeInValid
      case 'PP-IS-BIKE-2002':
        return ERROR_LANG.insuredMotorBikeHaveOneActivePolicy
      case 'PP-IS-BIKE-2001':
        return ERROR_LANG.theInsuredAlreadyHaveFourPolicies
      case 'PP-IS-HEALTH-3001':
        return ERROR_LANG.errorMsgForBlackListUserSupport
      case 'PP-PROOF-401':
        return 'Policy Proof Validation Failed'
      case 'PP-PAY-401':
        return 'Pihak lain sedang mencoba membayar, harap tunggu 15 menit untuk melakukan pembayaran'
      case 'PP-PAY-LATER-MAX-COUNT-400':
        return LANG_STRINGS.yourQuotaUsedForTheMonth
      case 'PP-STAFF-BAD-MOBILE-EXISTS-400':
        return LANG_STRINGS.numberAlreadyRegistered
      case 'PP-STAFF-BAD-NAME-400':
        return LANG_STRINGS.nameUpto22
      case 'PP-IS-PROD-EXC-HEALTH-4008':
        return LANG_STRINGS.insuredAlreadyHaveActivePolicy
      case 'PP-IS-PROD-EXC-HEALTH-4009':
        return LANG_STRINGS.bmiNotValid
      case 'PP-IS-PROD-EXC-HEALTH-4015':
        return LANG_STRINGS.ktpNikInvalid
      case 'PP-IS-PROD-EXC-HEALTH-4010':
        return LANG_STRINGS.ageDifferenceWhenMakingAndPaying
      case 'US105':
        return LANG_STRINGS.wait30MinsToChangePhoneNo
      case 'PP-BK-401':
        return LANG_STRINGS.agentNameMismatch
      case 'PP-BK-402':
        return LANG_STRINGS.duplicateBank
      case 'PP-BK-403':
        return LANG_STRINGS.holderNameMismatch
      default:
        return 'Sedang terjadi kesalahan, silahkan coba lagi nanti'
    }
  }
  switch (statusCode) {
    case 401:
      clearToken()
      window.location.replace('/login')
      return ''
    case 500:
      return 'Terjadi kesalahan, silahkan coba lagi'
    case 404:
      return 'Tidak ditemukan'
    case 400:
      return 'Request anda tidak dapat diproses sekarang'
    default:
      return 'Request tidak dapat diproses, silahkan coba lagi'
  }
}

export function queryBuilder(finalFilter) {
  const queryArray = []
  Object.keys(finalFilter).forEach((key) => {
    const keyValue = finalFilter[key]
    let query = ''
    const identifier = queryArray.length ? '&' : '?'
    if (Array.isArray(keyValue)) {
      keyValue.forEach((value) => {
        query += `${query ? '&' : ''}${key}=${value}`
      })
    } else if (keyValue) {
      query += `${key}=${keyValue}`
    }
    if (query) {
      queryArray.push(`${identifier}${query}`)
    }
  })
  return queryArray.join('')
}

export function urlMapper(url, params = {}) {
  let urlString = url
  Object.keys(params).forEach((key) => {
    urlString = urlString.replace(`{${key}}`, params[key])
    return urlString
  })
  return urlString
}

export function getQueryParams(params, url) {
  const href = url || window.location.href
  // this expression is to get the query strings
  const reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i')
  const queryString = reg.exec(href)
  return queryString ? queryString[1] : null
}

export function getDiffaultForAutoSuggest(data, dataKey, displayKey, defaultData) {
  if (!dataKey || !displayKey || dataKey === displayKey || !data) {
    // if dataKey and display key same then return same data
    return defaultData
  }
  const item = find(data, {
    [dataKey]: defaultData,
  })

  return item && item[displayKey]
}

export function prefixZero(number) {
  return number < 10 ? `0${number}` : number
}

export function isIos() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/.test(userAgent)
}

export function isAndroid() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /android/i.test(userAgent)
}

export function getDeviceType() {
  if (isIos()) {
    return 'ios'
  } else if (isAndroid()) {
    return 'android'
  } else {
    return 'website'
  }
}

export const isInStandaloneMode = () =>
  'standalone' in window.navigator && window.navigator.standalone

export const convertTo3digitFloat = (value) => parseFloat(parseFloat(value).toFixed(3))

export const validatePaymentTimeCounter = (date) => {
  const startDateTime = new Date(date)
  const startStamp = startDateTime.getTime()

  let newDate = new Date()
  let newStamp = newDate.getTime()

  newDate = new Date()
  newStamp = newDate.getTime()
  let diff = Math.round((newStamp - startStamp) / 1000)

  const noofDay = Math.floor(diff / (24 * 60 * 60))
  diff = diff - noofDay * 24 * 60 * 60
  const hour = Math.floor(diff / (60 * 60))
  if (!date || noofDay >= 3) {
    return false
  } else if (noofDay < 3 && hour < 24) {
    return true
  }
}

export function isMobileView() {
  var check = false
  /* eslint-disable no-useless-escape */
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check && window.innerWidth < 768
}

export function isWebView() {
  var standalone = window.navigator.standalone
  var userAgent = window.navigator.userAgent.toLowerCase()
  var safari = /safari/.test(userAgent)
  var ios = /iphone|ipod|ipad/.test(userAgent)
  const webViewInKitKatToLollipop = 'Chrome/30.0.0.0 Mobile'

  if (ios) {
    if (!standalone && safari) {
      return false
    } else if (!standalone && !safari) {
      return true
    }
  } else {
    if (userAgent.includes('wv') || userAgent.includes(webViewInKitKatToLollipop)) {
      return true
    } else {
      return false
    }
  }
}

export function isCreditAmount(amount) {
  return !(amount < 0)
}

export function getParamsFromUri(key) {
  // call this function with function.call(this, key)
  return lodashGet(this, `props.match.params.${key}`, '')
}

export function getValueFromLocationState(key) {
  return lodashGet(this, `props.location.state.${key}`, '')
}

export function getFirstKeyValueOfObj(obj) {
  const key = Object.keys(obj)[0]
  return obj[key]
}

export function getReferralAmountOnDate() {
  const currDate = new Date()
  const date = currDate.getDate()
  const month = currDate.getMonth() + 1
  if (date > 11 && date < 14 && month === 6) {
    return 30
  }

  return 10
}

export function getAppHostOrigin() {
  // this function check the existing host defined in env file
  if (isLocalhost) {
    return process.env.REACT_APP_LOCAL_API_END_POINT
  }
  return window.location.origin
}

export function getBrokerOsHostOrigin() {
  return ''
  // // this function check the existing host defined in env file
  // const origins = process.env.REACT_APP_API_ENDPOINT_INTEGRATIONS
  // console.log(process.env.REACT_APP_API_ENDPOINT_INTEGRATIONS, 'process.env.REACT_APP_API_ENDPOINT_INTEGRATIONS')
  // // const currentHostOrigin = window.location.origin
  // if (isLocalhost) {
  //   return process.env.REACT_APP_LOCAL_API_END_POINT_INTEGRATIONS
  // } else {
  //   return origins
  // }

  // return ''
}

export function copySharingData(sharingDate, successMsg = 'Menyalin ke clipboard berhasil') {
  // this handle copy referral code
  if (window.PPBridge) {
    // this for android device
    window.PPBridge.copy(sharingDate)
    return true
  } else {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(sharingDate).then(
        function () {
          NotificationManager.success(successMsg)
          return true
        },
        function (e) {
          if (copyToClipboard(sharingDate)) {
            NotificationManager.success(successMsg)
            return true
          } else {
            NotificationManager.success('Gagal Menyalin')
            return false
          }
        }
      )
    } else {
      // this is helpful to copy to data
      if (copyToClipboard(sharingDate)) {
        NotificationManager.success(successMsg)
      }
    }
  }
}

export function getYearRangeForGiveNumber(toYear = 2000) {
  return lodashRange(new Date().getFullYear(), toYear)
}

// this function used to convert - to _ like
// replaceHyphenToUnderScore("lippo-health-protection-silver") => "LIPPO_HEALTH_PROTECTION_SILVER"
export const replaceHyphenToUnderScore = (str) => str.split('-').join('_').toUpperCase()

// convert the number into K, M and B
export const convertNumberToMillions = (x) => {
  if (isNaN(x)) return x

  if (x < 9999) {
    return x
  }
  if (x < 1000000) {
    return Math.round(x / 1000) + ' K'
  }
  if (x < 10000000) {
    return x / 1000000 + ' Juta'
  }
  if (x < 1000000000) {
    return Math.round(x / 1000000) + ' juta'
  }
  if (x < 1000000000000) {
    return Math.round(x / 1000000000) + ' B'
  }

  return '1T+'
}

export const getTotalPolicyPremium = (addValues = [], subtractValues = []) => {
  const totalSum = addValues.reduce((acc, curr) => acc + curr, 0)
  const totalSubtract = subtractValues.reduce((acc, curr) => acc + curr, 0)

  return totalSum - totalSubtract
}

export const getNameErrorMsg = (value = '') => {
  let errorText = ''
  const isNumber = value.match(/[\d+]/g)
  if (value && value.length < 3) {
    if (value.match(/^[A-Za-z]{2,}/)) {
      errorText = ERROR_LANG.nameErrorRequied
    } else {
      errorText = ERROR_LANG.nameValidationError
    }
  } else if (value && !value.match(/^[A-Za-z]{1,}/)) {
    errorText = ERROR_LANG.nameMustBeginWithLetter
  } else if (value && isNumber && isNumber.length > 5) {
    errorText = ERROR_LANG.nameMayContain5digit
  } else {
    errorText = ERROR_LANG.nameValidationError
  }

  return errorText
}

export const getSlabLevelPercentage = (slabs, gwp, currentSlab, slabData) => {
  // blocks premium are not equally distributed that's why we are need to calculate
  // on basis of 33% block container
  let percentage = 0
  switch (currentSlab) {
    case 'SILVER': {
      const bronzeSlabData = find(slabs, { badge: 'BRONZE' })
      percentage =
        (gwp - bronzeSlabData.premium_limit) /
        (slabData.premium_limit - bronzeSlabData.premium_limit)
      // 37 percentage is the first block with margin
      // 32 is the percentage block for current block that is for silver to gold
      percentage = 37 + percentage * 32
      return percentage
    }
    case 'GOLD': {
      const GoldSlabData = find(slabs, { badge: 'SILVER' })
      percentage =
        (gwp - GoldSlabData.premium_limit) / (slabData.premium_limit - GoldSlabData.premium_limit)
      // 37 percentage is the first block with margin
      percentage = 68 + percentage * 33
      return percentage
    }
    case 'PLATINUM': {
      // if slab is platinum means already achieve 100%
      percentage = 100
      return percentage
    }
    default: {
      // handle the bronze level
      percentage = (gwp / slabData.premium_limit) * 37
      return percentage
    }
  }
}

export const getBadgePercentage = (badgeData = {}) => {
  // handle the percentage for the number line
  const {
    slabs,
    actual_slab: actualSlab,
    actual_gwp: actualGwp,
    estimated_gwp: estimatedGwp,
    estimated_slab: estimatedSlab,
  } = badgeData
  const actualSlabData = find(slabs, { badge: actualSlab }) || {}
  const estimatedSlabData = find(slabs, { badge: estimatedSlab }) || {}
  const actualPercentage = getSlabLevelPercentage(slabs, actualGwp, actualSlab, actualSlabData)
  const estimatedPercentage = getSlabLevelPercentage(
    slabs,
    estimatedGwp,
    estimatedSlab,
    estimatedSlabData
  )

  return {
    estimatedPercentage,
    actualPercentage,
  }
}

export const generateMonthYearMap = () => {
  // handle the month year
  // initialMonth is an integer
  const initialMonth = 8 // month index start from it denotes sept 2020
  const initialYear = 2020 // initial year at the time of release
  let currentMonth = moment().month()
  let currentYear = moment().year()
  const data = []

  function getData(month, year) {
    return {
      display: `${moment().month(month).format('MMM')} - ${year}`,
      value: `${month + 1}-${year}`,
    }
  }

  while (currentYear >= initialYear) {
    if (currentYear > initialYear) {
      while (currentMonth > 0) {
        data.push(getData(currentMonth, currentYear))
        currentMonth--
      }
      if (currentMonth === 0) {
        data.push(getData(currentMonth, currentYear))
        currentMonth = 11
        currentYear--
      }
    } else {
      while (currentMonth >= initialMonth) {
        data.push(getData(currentMonth, currentYear))
        currentMonth--
      }
      currentYear = undefined
    }
  }
  // {
  //   display: 'Sept 2020',
  //   value: '9-2020'
  // }
  return data
}

export const getFileNameFromUrl = (url) => {
  if (!url) return null
  const array = url.split('/')
  return array[array.length - 1]
}

export const getFileExtension = (file) => {
  var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i
  var extension = file && file.match(regexp)
  return extension && extension[1]
}

export const checkDownTimePeriod = () => {
  const startTime = Date.parse(new Date('June 21, 2022 23:00:00'))
  const endTime = Date.parse(new Date('June 22, 2022 01:00:00'))
  const currentTime = Date.parse(new Date())

  return startTime <= currentTime && currentTime <= endTime
}

export const showDownTimeNotification = () => {
  const startTime = Date.parse(new Date('May 17, 2022 02:30:00'))
  const endTime = Date.parse(new Date('May 17, 2022 06:30:00'))
  const currentTime = Date.parse(new Date())
  return currentTime >= startTime && currentTime <= endTime
}

export const getTaxForAgentAmount = (amount, taxSlabs = []) => {
  let tax = 0
  let taxableAmount = amount
  for (let index = 0; index < taxSlabs.length; index++) {
    // calculate the tax
    if (taxableAmount <= 0) break
    const slab = taxSlabs[index]
    if (slab.max && slab.max <= amount) {
      tax += (slab.max - slab.min) * slab.percentage
      taxableAmount = taxableAmount - slab.max
    } else {
      tax += taxableAmount * slab.percentage
      taxableAmount = 0
    }
  }
  return tax
}

// this service used to contact the the below services
export const contactService = (data = {}) => {
  switch (data.type) {
    case 'mobile':
      return window.open(`tel:${data.mobile}`)
    case 'email':
      return window.open(`mailto:${data.email}`)
    case 'whatsapp':
      return shareWithReqularWhatsApp(data.WAText, data.mobile)
    default:
      return sharingViaWhatsApp({
        mobile: data.mobile,
        text: data.WAText,
      })
  }
}

export const getAgentName = (name = '') => {
  if (!name) return null
  const [firstName, secondName = ''] = name.split(' ')
  return `${firstName} ${secondName}`
}

export const getGreetingMsg = () => {
  // 05:00 - 10:00 -> "Selamat pagi"
  // 10:01 - 16:00 -> "Selamat siang"
  // 16:01 - 18:00 -> "Selamat sore"
  // 18:01 - 04:59 -> " Selamat Malam"
  const time = parseFloat(moment().format('H.MM'))
  if (time >= '5.00' && time <= '10.00') {
    return 'goodMorning'
  } else if (time >= '10.01' && time <= '16.00') {
    return 'goodAfterNoon'
  } else if (time >= '16.01' && time <= '18.00') {
    return 'goodAfterNoon2'
  } else if ((time >= '18.01' && time <= '23.59') || time <= '4.59') {
    return 'goodNight'
  }
}

export const getAddressString = (addressData = {}) => {
  const address = [addressData.address] // this string always present
  if (addressData.city_name && addressData.postal_code) {
    address.push(`${addressData.city_name} ${addressData.postal_code}`)
  }
  if (addressData.province_name) {
    address.push(addressData.province_name)
  }
  return address.join(', ')
}

export const checkValidateStartDate = (date) => {
  return !moment(date, 'YYYY-MM-DD').isBefore(moment().format('YYYY-MM-DD'))
}

export const formatNPWP = (value) => {
  if (typeof value === 'string') {
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6')
  }
}

export const addCountryCode = (mobileNo) => {
  let phoneNumber = mobileNo
  if (!phoneNumber.includes('84-')) {
    const firstDigit = phoneNumber.substr(0, 1)
    if (firstDigit === '0') {
      phoneNumber = phoneNumber.replace('0', '')
    }
    const startNumber = phoneNumber.substr(0, 2)
    const restNumber = phoneNumber.substr(2, phoneNumber.length)
    if (startNumber !== '84' && restNumber.length <= 9) {
      phoneNumber = `84-${phoneNumber}`
    } else if (phoneNumber.length === 9) {
      // phone Number length in vietnam
      phoneNumber = `84-${phoneNumber}`
    }
  }
  return phoneNumber
}

export const extractValues = (obj) => {
  let result = ''
  const encounteredValues = new Set()

  const traverse = (obj) => {
    if (Array.isArray(obj)) {
      obj.forEach((item) => traverse(item))
    } else if (typeof obj === 'object' && obj !== null) {
      Object.values(obj).forEach((value) => traverse(value))
    } else {
      if (!encounteredValues.has(obj)) {
        result += obj + '\n'
        encounteredValues.add(obj)
      }
    }
  }

  traverse(obj)

  return result
}

export const mapNumberToMonth = (number, short = false) => {
  const shortMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Ags',
    'Sep',
    'Okt',
    'Nov',
    'Des',
  ]

  const months = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  if (number >= 0 && number <= 11) {
    if (short) {
      return shortMonths[number]
    } else {
      return months[number]
    }
  }
}

export const generateYearArray = (endYear) => {
  const currentYear = 2021
  const yearArray = []

  if (endYear >= currentYear) {
    for (let year = currentYear; year <= endYear; year++) {
      yearArray.push({ year })
    }
  }

  return yearArray
}
